var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('Loader'):_vm._e(),_c('generic-page',{ref:"gpage",attrs:{"main-banner":_vm.mainImg,"p-content":_vm.pContent,"p-title":_vm.pTitle}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }